// The search box above a location map (components/maps/placeSearch.js): suggestions while typing from Google's Places
// API (New), else the typed text looked up with the geocoder (Find, or Enter).

// Suggestions are asked for once this many characters are typed, after a short pause in the typing
export const SUGGEST_MIN_CHARS = 3;
export const SUGGEST_DELAY_MS = 250;
export const MAX_SUGGESTIONS = 5;

// Google's answer (AutocompleteSuggestion.fetchAutocompleteSuggestions) as the rows of the list: the main text (the
// place) and the secondary text (where it is). Answers that are not places are left out.
export function suggestionRows(response) {
	const suggestions = response && Array.isArray(response.suggestions) ? response.suggestions : [];
	const text = (part) => (part && typeof part.text === 'string' ? part.text : '');
	return suggestions
		.map((suggestion) => suggestion && suggestion.placePrediction)
		.filter((prediction) => prediction && (prediction.placeId || text(prediction.text)))
		.slice(0, MAX_SUGGESTIONS)
		.map((prediction, index) => {
			const main = text(prediction.mainText) || text(prediction.text);
			return { key: prediction.placeId || String(index), main, secondary: text(prediction.secondaryText), prediction };
		});
}

// The highlighted row after an arrow key: down from the box goes to the first, up from the first back to the box (-1)
export function nextHighlight(current, key, count) {
	if (!count) {
		return -1;
	}
	if (key === 'ArrowDown') {
		return current >= count - 1 ? count - 1 : current + 1;
	}
	if (key === 'ArrowUp') {
		return current <= 0 ? -1 : current - 1;
	}
	return current;
}

// A picked place (Place.fetchFields) in the shape the map page uses for a geocoder answer: { location, viewport }
export function placeGeometry(place) {
	if (!place || !place.location || typeof place.location.lat !== 'function') {
		return null;
	}
	return { location: place.location, viewport: place.viewport || null };
}

export function shouldSuggest(text) {
	return typeof text === 'string' && text.trim().length >= SUGGEST_MIN_CHARS;
}
